export class ErrorCodeConstant {
    static JOB_POST_TALENT_ASSIGNMENT_NOT_FOUND = 1600001;
    static JOB_POST_QUESTIONNAIRE_SOURCE_INVALID = 890003;
    static JOB_POST_QUESTIONNAIRE_PARENT_MISSING = 890004;
    static JOB_POST_QUESTIONNAIRE_LINK_INVALID = 890005;
    static JOB_POST_QUESTIONNAIRE_LINK_CYCLE = 890006;
    static COMPETITION_NOT_READY_TO_PUBLISH = 2300008;
}
